import type { BriefingStepLike } from './types'

export function findFirstIncompleteRequiredStep<T extends BriefingStepLike>(
  steps: T[]
): T | null {
  return (
    steps.find((step) => {
      if (step.requiredness !== 'required') {
        return false
      }
      return step.status === 'open' || step.status === 'partial'
    }) ?? null
  )
}
